import React, { useEffect, useState } from 'react';
import { TextField, Button } from '@mui/material';
import { SingleSelect } from '../select-types/SingleSelect.js';
import { UtilService } from '../../services/UtilService.js';
import Excel from './Excel.js';
import { Item } from '../../models.ts';
import EditCalculator from './EditCalculator.js';

const CarportCalculator = ({ carportObj, carportMap, isAdmin, handleSubmit }) => {
  const [carState, setCarState] = useState({});
  const [disableCalculate, setDisableCalculate] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const utilService = new UtilService();

  useEffect(() => {
    if (carportObj && carportMap) {
      let obj = { ...carportObj };
      carportObj.fields.forEach(field => {
        obj[field.id] = { ...field };
      });
      setCarState(obj);
    }
    return () => {
      setCarState({});
      setDisableCalculate(true);
    };
  }, [carportObj, carportMap]);

  function handleChange(field, value) {
    switch (field.type) {
      case 'select':
        let item = carportMap[field.collection].find(i => i.id === value);
        field.selection = JSON.parse(JSON.stringify(item));
        break;
      case 'text':
      case 'number':
        if (!field.selection) {
          field.selection = new Item();
        }
        field.selection.value = field.type === 'number' ? Number(value) : value;
        break;
      default:
        break;
    }
    setCarState({ ...carState, [field.id]: { ...field } });
    checkDisabled();
  }

  function checkDisabled() {
    let disabled = false;
    if (carState?.fields?.length) {
      for (let field of carState.fields) {
        if (carState[field.id].show && carState[field.id].required && !disabled) {
          if (field.type === 'select') {
            disabled = carState[field.id].selection === undefined;
          } else if (field.type === 'text') {
            disabled = !carState[field.id].selection?.value?.length;
          } else if (field.type === 'number') {
            disabled = !carState[field.id].selection?.value || carState[field.id].selection?.value === 0;
          }
        }
      }
    }
    setDisableCalculate(disabled);
  }

  function calculate() {
    let newObj = handleSubmit(carState, carportMap);
    setCarState({ ...newObj });
  }

  function onEdit() {
    document.getElementById('container').style.width = isEditing ? '300px' : '90vw';
    setIsEditing(!isEditing);
  }

  if(isEditing) {
    return (
      <EditCalculator title={'Deck Calculator'}
        calculator={carState}
        itemList={carportMap}
        onFinish={onEdit}
      />
    )
  } else {
    return (
      <div>
        <div>
          {isAdmin &&
            <Button variant='outlined' onClick={onEdit}>
              {isEditing ? 'Done' : 'Edit'}
            </Button>
          }
          <h1>Carport Calculator</h1>
        </div>
        <div>
          {carState.fields?.length &&
            carState.fields.map(field => {
              if (carState[field.id].show) {
                return (
                  <div key={field.id}>
                    {field.type === 'select' &&
                      <SingleSelect
                        field={carState[field.id]}
                        label={field.name}
                        optionList={carportMap[field.collection]}
                        handleChange={handleChange}>
                      </SingleSelect>
                    }
                    {(field.type === 'text' || field.type === 'number') &&
                      <TextField
                        error={carState[field.id].required &&
                          (!carState[field.id].selection?.value || carState[field.id].selection?.value === 0)}
                        label={field.name}
                        defaultValue={carState[field.id].value || ''}
                        helperText={null}
                        required={field.required}
                        onChange={(e) => handleChange(field, e.target.value)}
                        variant="standard"
                      />
                    }
                    {!field.type &&
                      <div className='total'>
                        <span>{field.name} = </span>
                        <span>{utilService.formatCurrency(carState[field.property]) || 0}</span>
                      </div>
                    }
                  </div>
                )
              } else {
                return null;
              }
            })
          }
        </div>
        <div className='buttonGroupSpaced'>
          <Button variant="outlined"
            onClick={calculate}
            disabled={disableCalculate}
          >
            Calculate
          </Button>
          {!disableCalculate && carState.total > 0 &&
            <Excel calc={carState}></Excel>
          }
        </div>
      </div>
    );
  }
};

export default CarportCalculator;